export enum SystemEventType {
    NONE = 0,

    // User Events
    USER_REGISTERED = 1,
    USER_REGISTRATION_COMPLETED = 2,
    USER_LOGGED_IN = 3,
    USER_LOGGED_OUT = 4,
    USER_PASSWORD_RESET_REQUESTED = 5,
    USER_PASSWORD_RESET_COMPLETED = 6,
    USER_REGISTRATION_FAILED = 7,
    USER_LOGIN_FAILED = 8,
    USER_LOGOUT_FAILED = 9,
    USER_PASSWORD_RESET_REQUEST_FAILED = 10,
    USER_PASSWORD_RESET_FAILED = 11,

    // Role Events
    ROLE_ADDED = 50,
    ROLE_UPDATED = 51,
    ROLE_DELETED = 52,

    // Product Feature Events
    PRODUCT_FEATURE_ADDED = 100,
    PRODUCT_FEATURE_UPDATED = 101,
    PRODUCT_FEATURE_DELETED = 102,
}
